<button mat-button [routerLink]="'/clients/history-result-details'" [state]="{data: params?.value}"
    matTooltip="Detalles">
    <mat-icon>show_chart</mat-icon>
</button>